import RoomJoin from "../components/webrtc/RoomJoin";

export default [
  {
    path: "/webrtc/rooms/:roomId/join",
    name: "webrtcJoinRoom",
    component: RoomJoin,
  },
];
